import { useState } from "react";

export default function LoginForm({ onLogin, t }) {
    const [loginType, setLoginType] = useState("retail"); // "retail" | "admin"
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email.trim()) { setError("請輸入 Email"); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
            setError("請輸入有效的 Email 格式"); return;
        }
        if (!password) { setError("請輸入密碼"); return; }
        if (password.length < 6) { setError("密碼至少需要 6 位"); return; }
        onLogin({ email: email.trim(), accountType: loginType });
    };

    const inputStyle = {
        background: t.inputBg, border: `1px solid ${t.border}`, color: t.text,
        borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none",
        width: "100%", boxSizing: "border-box"
    };

    const tabStyle = (active) => ({
        flex: 1, padding: "9px 8px", borderRadius: 8, cursor: "pointer",
        fontSize: 12, fontWeight: 600,
        background: active ? t.accentBg : t.inputBg,
        border: `1px solid ${active ? t.accent : t.border}`,
        color: active ? t.accentText : t.textMuted
    });

    return (
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {/* Login Type Toggle */}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <label style={{ color: t.textMuted, fontSize: 13, fontWeight: 500 }}>登入方式</label>
                <div style={{ display: "flex", gap: 8 }}>
                    <button type="button" onClick={() => { setLoginType("retail"); setError(""); }}
                        style={tabStyle(loginType === "retail")}>
                        🏪 商戶登入
                    </button>
                    <button type="button" onClick={() => { setLoginType("admin"); setError(""); }}
                        style={tabStyle(loginType === "admin")}>
                        🔐 管理員登入
                    </button>
                </div>
            </div>

            {/* Email */}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <label style={{ color: t.textMuted, fontSize: 13, fontWeight: 500 }}>登入 Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(""); }}
                    placeholder={loginType === "admin" ? "admin@aeye.com" : "your@email.com"}
                    required
                    style={inputStyle}
                />
            </div>

            {/* Password */}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <label style={{ color: t.textMuted, fontSize: 13, fontWeight: 500 }}>密碼</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setError(""); }}
                    placeholder="••••••••"
                    required
                    style={inputStyle}
                />
            </div>

            {error && <p style={{ color: t.danger, fontSize: 13, margin: 0 }}>⚠️ {error}</p>}

            <button
                type="submit"
                style={{
                    padding: "12px", border: "none", color: "white",
                    borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: "pointer",
                    background: `linear-gradient(135deg, #1a3a5c 0%, #2a9d8f 100%)`
                }}
            >
                {loginType === "admin" ? "🔐 管理員登入" : "🏪 商戶登入"}
            </button>
        </form>
    );
}
